<template>
    <ul class="n2-valid" v-bind:class="{'n2-validation-summary':hasError}">
        <li>{{ error }}</li>
    </ul>
</template>
<script>
    export default {
        name: 'ResultSummary',
        props: {
            error: String,
        },
        computed: {
            hasError: function () {
                return this.error ? true : false
            }
        }
    }
</script>